import React from 'react';

interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md';
}

const statusColors: Record<string, { bg: string; text: string }> = {
  active: { bg: '#DCFCE7', text: '#166534' },
  inactive: { bg: '#F3F4F6', text: '#6B7280' },
  suspended: { bg: '#FEE2E2', text: '#991B1B' },
  // `erased` joins `suspended` as one of the two reserved member states
  // (SOR-590). It reads muted rather than alarming: an erased membership is a
  // resolved, terminal row, not one that needs an operator's attention.
  erased: { bg: '#E5E7EB', text: '#374151' },
  closed: { bg: '#F3F4F6', text: '#6B7280' },
  pending: { bg: '#FEF3C7', text: '#92400E' },
  current: { bg: '#DCFCE7', text: '#166534' },
  'past-due': { bg: '#FEE2E2', text: '#991B1B' },
  prepaid: { bg: '#DBEAFE', text: '#1E40AF' },
  synced: { bg: '#DCFCE7', text: '#166534' },
  error: { bg: '#FEE2E2', text: '#991B1B' },
  'not-linked': { bg: '#F3F4F6', text: '#6B7280' },
  executed: { bg: '#DCFCE7', text: '#166534' },
  received: { bg: '#DBEAFE', text: '#1E40AF' },
  expired: { bg: '#F3F4F6', text: '#6B7280' },
  scheduled: { bg: '#FEF3C7', text: '#92400E' },
  draft: { bg: '#FEF3C7', text: '#92400E' },
  archived: { bg: '#F3F4F6', text: '#6B7280' },
  discontinued: { bg: '#F3F4F6', text: '#6B7280' },
  'temporarily-closed': { bg: '#FEF3C7', text: '#92400E' },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'sm' }) => {
  const colors = statusColors[status] || { bg: '#F3F4F6', text: '#6B7280' };
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm';

  const formatStatus = (s: string) =>
    s.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${sizeClasses}`}
      style={{ backgroundColor: colors.bg, color: colors.text }}
    >
      {formatStatus(status)}
    </span>
  );
};

export default StatusBadge;
